import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"
import React from "react"
import ReactDOM from "react-dom"
import { AppContainer } from "react-hot-loader"
import { COMMIT } from "Shared/config/consts"
import store from "Shared/store"
import { isInternal, isProd } from "Shared/utils/helpers"
import App from "./App"

if (isProd && !isInternal) {
    console.log = () => {}
    console.error = () => {}
    console.warn = () => {}
    console.info = () => {}
}

const render = (Component: any) => {
    ReactDOM.render(Component, document.getElementById("root"))
}

let appTag = (
    <AppContainer>
        <App store={store} />
    </AppContainer>
)

if (module.hot) {
    module.hot.accept("./App.tsx", () => {
        const NewApp = require("./App").default
        render(
            <AppContainer>
                <NewApp store={store} />
            </AppContainer>
        )
    })
}

if (isProd) {
    Sentry.init({
        // Config for Sentry
        dsn: process.env.SENTRY_OPTION_DSN_URL,
        environment: process.env.DEPLOY_ENVIRONMENT,
        // Config for the release to map errors to version and commit
        release: process.env.npm_package_version,
        dist: COMMIT,

        integrations: [new BrowserTracing()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        ignoreErrors: ["ResizeObserver loop limit exceeded"],
        attachStacktrace: true,
    })

    appTag = <App store={store} />
}

render(appTag)
